function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEeiPopularity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115,
    height: 180,
    viewBox: "0 0 115 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EEI Popularity") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard 1",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Green"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_1",
    "data-name": "Rounded Rectangle 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 45.5,
    width: 114,
    height: 14,
    rx: 6.5,
    ry: 6.5,
    style: {
      fill: "#fbbf01"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,46a6,6,0,0,1,6,6v1a6,6,0,0,1-6,6H7a6,6,0,0,1-6-6V52a6,6,0,0,1,6-6H108m0-1H7a7,7,0,0,0-7,7v1a7,7,0,0,0,7,7H108a7,7,0,0,0,7-7V52a7,7,0,0,0-7-7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 52.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy",
    "data-name": "Ellipse 1 copy"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 52.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_2",
    "data-name": "Ellipse 1 copy 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 52.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_3",
    "data-name": "Ellipse 1 copy 3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 52.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_4",
    "data-name": "Ellipse 1 copy 4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 52.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_5",
    "data-name": "Ellipse 1 copy 5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 52.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_6",
    "data-name": "Ellipse 1 copy 6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 52.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_7",
    "data-name": "Ellipse 1 copy 7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 52.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_8",
    "data-name": "Ellipse 1 copy 8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 52.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_9",
    "data-name": "Ellipse 1 copy 9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 52.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_20",
    "data-name": "Ellipse 1 copy 20"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 52.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Green_copy",
    "data-name": "Green copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_1-2",
    "data-name": "Rounded Rectangle 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 60.5,
    width: 114,
    height: 14,
    rx: 6.5,
    ry: 6.5,
    style: {
      fill: "#fbbf01"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,61a6,6,0,0,1,6,6v1a6,6,0,0,1-6,6H7a6,6,0,0,1-6-6V67a6,6,0,0,1,6-6H108m0-1H7a7,7,0,0,0-7,7v1a7,7,0,0,0,7,7H108a7,7,0,0,0,7-7V67a7,7,0,0,0-7-7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1-2",
    "data-name": "Ellipse 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 67.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy-2",
    "data-name": "Ellipse 1 copy"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 67.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_2-2",
    "data-name": "Ellipse 1 copy 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 67.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_3-2",
    "data-name": "Ellipse 1 copy 3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 67.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_4-2",
    "data-name": "Ellipse 1 copy 4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 67.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_5-2",
    "data-name": "Ellipse 1 copy 5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 67.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_6-2",
    "data-name": "Ellipse 1 copy 6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 67.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_7-2",
    "data-name": "Ellipse 1 copy 7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 67.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_8-2",
    "data-name": "Ellipse 1 copy 8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 67.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_9-2",
    "data-name": "Ellipse 1 copy 9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 67.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_19",
    "data-name": "Ellipse 1 copy 19"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 67.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Green_copy_2",
    "data-name": "Green copy 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_1-3",
    "data-name": "Rounded Rectangle 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 75.5,
    width: 114,
    height: 14,
    rx: 6.5,
    ry: 6.5,
    style: {
      fill: "#d4e9b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,76a6,6,0,0,1,6,6v1a6,6,0,0,1-6,6H7a6,6,0,0,1-6-6V82a6,6,0,0,1,6-6H108m0-1H7a7,7,0,0,0-7,7v1a7,7,0,0,0,7,7H108a7,7,0,0,0,7-7V82a7,7,0,0,0-7-7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1-3",
    "data-name": "Ellipse 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 82.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy-3",
    "data-name": "Ellipse 1 copy"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 82.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_2-3",
    "data-name": "Ellipse 1 copy 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 82.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_3-3",
    "data-name": "Ellipse 1 copy 3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 82.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_4-3",
    "data-name": "Ellipse 1 copy 4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 82.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_5-3",
    "data-name": "Ellipse 1 copy 5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 82.5,
    r: 3.6,
    style: {
      fill: "#dfefc9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_6-3",
    "data-name": "Ellipse 1 copy 6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 82.5,
    r: 3.6,
    style: {
      fill: "#dfefc9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_7-3",
    "data-name": "Ellipse 1 copy 7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 82.5,
    r: 3.6,
    style: {
      fill: "#dfefc9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_8-3",
    "data-name": "Ellipse 1 copy 8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 82.5,
    r: 3.6,
    style: {
      fill: "#dfefc9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_9-3",
    "data-name": "Ellipse 1 copy 9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 82.5,
    r: 3.6,
    style: {
      fill: "#dfefc9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_18",
    "data-name": "Ellipse 1 copy 18"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 82.5,
    r: 3.6,
    style: {
      fill: "#dfefc9"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Green_copy_3",
    "data-name": "Green copy 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_1-4",
    "data-name": "Rounded Rectangle 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 90.5,
    width: 114,
    height: 14,
    rx: 6.5,
    ry: 6.5,
    style: {
      fill: "#d4e9b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,91a6,6,0,0,1,6,6v1a6,6,0,0,1-6,6H7a6,6,0,0,1-6-6V97a6,6,0,0,1,6-6H108m0-1H7a7,7,0,0,0-7,7v1a7,7,0,0,0,7,7H108a7,7,0,0,0,7-7V97a7,7,0,0,0-7-7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1-4",
    "data-name": "Ellipse 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 97.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy-4",
    "data-name": "Ellipse 1 copy"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 97.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_2-4",
    "data-name": "Ellipse 1 copy 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 97.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_3-4",
    "data-name": "Ellipse 1 copy 3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 97.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_4-4",
    "data-name": "Ellipse 1 copy 4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 97.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_5-4",
    "data-name": "Ellipse 1 copy 5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 97.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_6-4",
    "data-name": "Ellipse 1 copy 6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 97.5,
    r: 3.6,
    style: {
      fill: "#dfefc9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_7-4",
    "data-name": "Ellipse 1 copy 7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 97.5,
    r: 3.6,
    style: {
      fill: "#dfefc9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_8-4",
    "data-name": "Ellipse 1 copy 8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 97.5,
    r: 3.6,
    style: {
      fill: "#dfefc9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_9-4",
    "data-name": "Ellipse 1 copy 9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 97.5,
    r: 3.6,
    style: {
      fill: "#dfefc9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_17",
    "data-name": "Ellipse 1 copy 17"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 97.5,
    r: 3.6,
    style: {
      fill: "#dfefc9"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Green_copy_4",
    "data-name": "Green copy 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_1-5",
    "data-name": "Rounded Rectangle 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 105.5,
    width: 114,
    height: 14,
    rx: 6.5,
    ry: 6.5,
    style: {
      fill: "#d4e9b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,106a6,6,0,0,1,6,6v1a6,6,0,0,1-6,6H7a6,6,0,0,1-6-6v-1a6,6,0,0,1,6-6H108m0-1H7a7,7,0,0,0-7,7v1a7,7,0,0,0,7,7H108a7,7,0,0,0,7-7v-1a7,7,0,0,0-7-7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1-5",
    "data-name": "Ellipse 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 112.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy-5",
    "data-name": "Ellipse 1 copy"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 112.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_2-5",
    "data-name": "Ellipse 1 copy 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 112.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_3-5",
    "data-name": "Ellipse 1 copy 3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 112.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_4-5",
    "data-name": "Ellipse 1 copy 4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 112.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_5-5",
    "data-name": "Ellipse 1 copy 5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 112.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_6-5",
    "data-name": "Ellipse 1 copy 6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 112.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_7-5",
    "data-name": "Ellipse 1 copy 7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 112.5,
    r: 3.6,
    style: {
      fill: "#dfefc9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_8-5",
    "data-name": "Ellipse 1 copy 8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 112.5,
    r: 3.6,
    style: {
      fill: "#dfefc9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_9-5",
    "data-name": "Ellipse 1 copy 9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 112.5,
    r: 3.6,
    style: {
      fill: "#dfefc9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_16",
    "data-name": "Ellipse 1 copy 16"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 112.5,
    r: 3.6,
    style: {
      fill: "#dfefc9"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Green_copy_5",
    "data-name": "Green copy 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_1-6",
    "data-name": "Rounded Rectangle 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 120.5,
    width: 114,
    height: 14,
    rx: 6.5,
    ry: 6.5,
    style: {
      fill: "#d4e9b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,121a6,6,0,0,1,6,6v1a6,6,0,0,1-6,6H7a6,6,0,0,1-6-6v-1a6,6,0,0,1,6-6H108m0-1H7a7,7,0,0,0-7,7v1a7,7,0,0,0,7,7H108a7,7,0,0,0,7-7v-1a7,7,0,0,0-7-7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1-6",
    "data-name": "Ellipse 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 127.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy-6",
    "data-name": "Ellipse 1 copy"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 127.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_2-6",
    "data-name": "Ellipse 1 copy 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 127.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_3-6",
    "data-name": "Ellipse 1 copy 3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 127.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_4-6",
    "data-name": "Ellipse 1 copy 4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 127.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_5-6",
    "data-name": "Ellipse 1 copy 5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 127.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_6-6",
    "data-name": "Ellipse 1 copy 6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 127.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_7-6",
    "data-name": "Ellipse 1 copy 7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 127.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_8-6",
    "data-name": "Ellipse 1 copy 8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 127.5,
    r: 3.6,
    style: {
      fill: "#dfefc9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_9-6",
    "data-name": "Ellipse 1 copy 9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 127.5,
    r: 3.6,
    style: {
      fill: "#dfefc9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_15",
    "data-name": "Ellipse 1 copy 15"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 127.5,
    r: 3.6,
    style: {
      fill: "#dfefc9"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Green_copy_6",
    "data-name": "Green copy 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_1-7",
    "data-name": "Rounded Rectangle 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 135.5,
    width: 114,
    height: 14,
    rx: 6.5,
    ry: 6.5,
    style: {
      fill: "#d4e9b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,136a6,6,0,0,1,6,6v1a6,6,0,0,1-6,6H7a6,6,0,0,1-6-6v-1a6,6,0,0,1,6-6H108m0-1H7a7,7,0,0,0-7,7v1a7,7,0,0,0,7,7H108a7,7,0,0,0,7-7v-1a7,7,0,0,0-7-7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1-7",
    "data-name": "Ellipse 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 142.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy-7",
    "data-name": "Ellipse 1 copy"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 142.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_2-7",
    "data-name": "Ellipse 1 copy 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 142.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_3-7",
    "data-name": "Ellipse 1 copy 3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 142.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_4-7",
    "data-name": "Ellipse 1 copy 4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 142.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_5-7",
    "data-name": "Ellipse 1 copy 5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 142.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_6-7",
    "data-name": "Ellipse 1 copy 6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 142.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_7-7",
    "data-name": "Ellipse 1 copy 7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 142.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_8-7",
    "data-name": "Ellipse 1 copy 8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 142.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_9-7",
    "data-name": "Ellipse 1 copy 9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 142.5,
    r: 3.6,
    style: {
      fill: "#dfefc9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_14",
    "data-name": "Ellipse 1 copy 14"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 142.5,
    r: 3.6,
    style: {
      fill: "#dfefc9"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Green_copy_7",
    "data-name": "Green copy 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_1-8",
    "data-name": "Rounded Rectangle 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 150.5,
    width: 114,
    height: 14,
    rx: 6.5,
    ry: 6.5,
    style: {
      fill: "#d4e9b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,151a6,6,0,0,1,6,6v1a6,6,0,0,1-6,6H7a6,6,0,0,1-6-6v-1a6,6,0,0,1,6-6H108m0-1H7a7,7,0,0,0-7,7v1a7,7,0,0,0,7,7H108a7,7,0,0,0,7-7v-1a7,7,0,0,0-7-7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1-8",
    "data-name": "Ellipse 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 157.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy-8",
    "data-name": "Ellipse 1 copy"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 157.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_2-8",
    "data-name": "Ellipse 1 copy 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 157.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_3-8",
    "data-name": "Ellipse 1 copy 3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 157.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_4-8",
    "data-name": "Ellipse 1 copy 4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 157.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_5-8",
    "data-name": "Ellipse 1 copy 5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 157.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_6-8",
    "data-name": "Ellipse 1 copy 6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 157.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_7-8",
    "data-name": "Ellipse 1 copy 7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 157.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_8-8",
    "data-name": "Ellipse 1 copy 8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 157.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_9-8",
    "data-name": "Ellipse 1 copy 9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 157.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_13",
    "data-name": "Ellipse 1 copy 13"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 157.5,
    r: 3.6,
    style: {
      fill: "#dfefc9"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Green_copy_8",
    "data-name": "Green copy 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_1-9",
    "data-name": "Rounded Rectangle 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 165.5,
    width: 114,
    height: 14,
    rx: 6.5,
    ry: 6.5,
    style: {
      fill: "#d4e9b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,166a6,6,0,0,1,6,6v1a6,6,0,0,1-6,6H7a6,6,0,0,1-6-6v-1a6,6,0,0,1,6-6H108m0-1H7a7,7,0,0,0-7,7v1a7,7,0,0,0,7,7H108a7,7,0,0,0,7-7v-1a7,7,0,0,0-7-7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1-9",
    "data-name": "Ellipse 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 172.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy-9",
    "data-name": "Ellipse 1 copy"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 172.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_2-9",
    "data-name": "Ellipse 1 copy 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 172.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_3-9",
    "data-name": "Ellipse 1 copy 3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 172.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_4-9",
    "data-name": "Ellipse 1 copy 4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 172.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_5-9",
    "data-name": "Ellipse 1 copy 5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 172.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_6-9",
    "data-name": "Ellipse 1 copy 6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 172.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_7-9",
    "data-name": "Ellipse 1 copy 7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 172.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_8-9",
    "data-name": "Ellipse 1 copy 8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 172.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_9-9",
    "data-name": "Ellipse 1 copy 9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 172.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_12",
    "data-name": "Ellipse 1 copy 12"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 172.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Yellow"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_1-10",
    "data-name": "Rounded Rectangle 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 30.5,
    width: 114,
    height: 14,
    rx: 6.5,
    ry: 6.5,
    style: {
      fill: "#fbbf01"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,31a6,6,0,0,1,6,6v1a6,6,0,0,1-6,6H7a6,6,0,0,1-6-6V37a6,6,0,0,1,6-6H108m0-1H7a7,7,0,0,0-7,7v1a7,7,0,0,0,7,7H108a7,7,0,0,0,7-7V37a7,7,0,0,0-7-7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1-10",
    "data-name": "Ellipse 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 37.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy-10",
    "data-name": "Ellipse 1 copy"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 37.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_2-10",
    "data-name": "Ellipse 1 copy 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 37.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_3-10",
    "data-name": "Ellipse 1 copy 3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_4-10",
    "data-name": "Ellipse 1 copy 4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 37.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_5-10",
    "data-name": "Ellipse 1 copy 5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 37.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_6-10",
    "data-name": "Ellipse 1 copy 6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 37.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_7-10",
    "data-name": "Ellipse 1 copy 7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 37.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_8-10",
    "data-name": "Ellipse 1 copy 8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 37.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_9-10",
    "data-name": "Ellipse 1 copy 9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 37.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_21",
    "data-name": "Ellipse 1 copy 21"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 37.5,
    r: 3.6,
    style: {
      fill: "#fcd24e"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Red"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_1-11",
    "data-name": "Rounded Rectangle 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 114,
    height: 14,
    rx: 6.5,
    ry: 6.5,
    style: {
      fill: "#e04239"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,1a6,6,0,0,1,6,6V8a6,6,0,0,1-6,6H7A6,6,0,0,1,1,8V7A6,6,0,0,1,7,1H108m0-1H7A7,7,0,0,0,0,7V8a7,7,0,0,0,7,7H108a7,7,0,0,0,7-7V7a7,7,0,0,0-7-7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1-11",
    "data-name": "Ellipse 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 3.6,
    style: {
      fill: "#e8716b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy-11",
    "data-name": "Ellipse 1 copy"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 7.5,
    r: 3.6,
    style: {
      fill: "#e8716b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_2-11",
    "data-name": "Ellipse 1 copy 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 7.5,
    r: 3.6,
    style: {
      fill: "#e8716b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_3-11",
    "data-name": "Ellipse 1 copy 3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 7.5,
    r: 3.6,
    style: {
      fill: "#e8716b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_4-11",
    "data-name": "Ellipse 1 copy 4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 7.5,
    r: 3.6,
    style: {
      fill: "#e8716b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_5-11",
    "data-name": "Ellipse 1 copy 5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 7.5,
    r: 3.6,
    style: {
      fill: "#e8716b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_6-11",
    "data-name": "Ellipse 1 copy 6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 7.5,
    r: 3.6,
    style: {
      fill: "#e8716b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_7-11",
    "data-name": "Ellipse 1 copy 7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 7.5,
    r: 3.6,
    style: {
      fill: "#e8716b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_8-11",
    "data-name": "Ellipse 1 copy 8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 7.5,
    r: 3.6,
    style: {
      fill: "#e8716b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_9-11",
    "data-name": "Ellipse 1 copy 9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 7.5,
    r: 3.6,
    style: {
      fill: "#e8716b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_10",
    "data-name": "Ellipse 1 copy 10"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 7.5,
    r: 3.6,
    style: {
      fill: "#e8716b"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Red_copy",
    "data-name": "Red copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_1-12",
    "data-name": "Rounded Rectangle 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 15.5,
    width: 114,
    height: 14,
    rx: 6.5,
    ry: 6.5,
    style: {
      fill: "#e04239"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,16a6,6,0,0,1,6,6v1a6,6,0,0,1-6,6H7a6,6,0,0,1-6-6V22a6,6,0,0,1,6-6H108m0-1H7a7,7,0,0,0-7,7v1a7,7,0,0,0,7,7H108a7,7,0,0,0,7-7V22a7,7,0,0,0-7-7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy-12",
    "data-name": "Ellipse 1 copy"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 22.5,
    r: 3.6,
    style: {
      fill: "#e8716b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_22",
    "data-name": "Ellipse 1 copy 22"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 22.5,
    r: 3.6,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_2-12",
    "data-name": "Ellipse 1 copy 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 22.5,
    r: 3.6,
    style: {
      fill: "#e8716b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_3-12",
    "data-name": "Ellipse 1 copy 3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 22.5,
    r: 3.6,
    style: {
      fill: "#e8716b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_4-12",
    "data-name": "Ellipse 1 copy 4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 22.5,
    r: 3.6,
    style: {
      fill: "#e8716b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_5-12",
    "data-name": "Ellipse 1 copy 5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 22.5,
    r: 3.6,
    style: {
      fill: "#e8716b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_6-12",
    "data-name": "Ellipse 1 copy 6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 22.5,
    r: 3.6,
    style: {
      fill: "#e8716b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_7-12",
    "data-name": "Ellipse 1 copy 7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 22.5,
    r: 3.6,
    style: {
      fill: "#e8716b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_8-12",
    "data-name": "Ellipse 1 copy 8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 22.5,
    r: 3.6,
    style: {
      fill: "#e8716b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_9-12",
    "data-name": "Ellipse 1 copy 9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 22.5,
    r: 3.6,
    style: {
      fill: "#e8716b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1_copy_11",
    "data-name": "Ellipse 1 copy 11"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 22.5,
    r: 3.6,
    style: {
      fill: "#e8716b"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEeiPopularity);
export default __webpack_public_path__ + "static/media/eei-popularity.0bc8c3537e3eb7dbc7de597fa69267de.svg";
export { ForwardRef as ReactComponent };